var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('RoundButton',{staticClass:"w-full md:w-auto flex justify-center md:justify-start items-center gap-x-2",attrs:{"context":"primary-outline"},on:{"click":function($event){return _vm.getSharableLink()}}},[_c('v-icon',{attrs:{"name":"share"}}),_vm._v(" "),_c('span',[_vm._v("Share Report")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }